<template>
  <a :href="link" class="link">{{ text ? text : link }}</a>
</template>

<script>
// TODO: Нужно сделать пропсы isBlank, isDashed, noBorder
export default {
  props: {
    link: {
      type: String,
      required: true,
      default: ''
    },

    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.link {
  color: $green;
  border-bottom: 1px solid $green;
  transition: color 0.3s;

  &:hover {
    color: $green-hover;
    transition: color 0.3s;
  }
}
</style>
